import axios from "axios";
import { message } from "antd";
import { completeOnboarding } from "./userService";
import { BACKEND_URL } from "../constants/Constant";

const API_BASE_URL = `${BACKEND_URL}/channel`;

export const fetchChannels = async (setState) => {
  const { setDiscordChannels, setTelegramChannels, setChannelLoading } = setState;
  
  setChannelLoading(true);
  try {
    const userId = localStorage.getItem("userId");
    const [discordChannels, telegramChannels] = await Promise.all([
      fetchChannelsByType(userId, 'discord'),
      fetchChannelsByType(userId, 'telegram')
    ]);
    
    setDiscordChannels(discordChannels);
    setTelegramChannels(telegramChannels);
    return { discordChannels, telegramChannels };
  } catch (error) {
    message.error(error.message);
    throw error;
  } finally {
    setChannelLoading(false);
  }
};

export const updateDiscordChannels = async (user_id, channels) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/user/discord-channels`, {
      user_id,
      channels,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating Discord channels:", error);
    throw new Error(error.response?.data?.error || error.response?.data?.message || "Failed to update Discord channels");
  }
};

export const updateTelegramChannels = async (user_id, channels) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/user/telegram-channels`, {
      user_id,
      channels,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update Telegram channels");
  }
};

export const fetchChannelsByType = async (user_id, type) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/user/channels`, {
      params: { user_id, type },
    });
    return response.data.channels;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch channels");
  }
};

export const addChannel = (state, setState) => {
  const { step, channelId, channelName, sport, discordChannels, telegramChannels } = state;
  const { setChannelId, setChannelName, setSport, setDiscordChannels, setTelegramChannels } = setState;

  if (channelId && channelName && sport) {
    if (step === "discord") {
      setDiscordChannels([...discordChannels, { channelID: channelId, channelName, sports: sport }]);
    } else {
      setTelegramChannels([...telegramChannels, { channelID: channelId, channelName, sports: sport }]);
    }
    setChannelId("");
    setChannelName("");
    setSport("");
  } else {
    message.warning("Please fill all fields to add a channel.");
  }
};

export const removeChannel = (state, setState, index) => {
  const { step, discordChannels, telegramChannels } = state;
  const { setDiscordChannels, setTelegramChannels } = setState;

  if (step === "discord") {
    setDiscordChannels(discordChannels.filter((_, i) => i !== index));
  } else {
    setTelegramChannels(telegramChannels.filter((_, i) => i !== index));
  }
};

export const handleChannelOperations = async ({
  state,
  setState,
  isOnboarding = false,
  onSuccessCallback
}) => {
  const { discordChannels, telegramChannels } = state;
  const { setLoading } = setState;

  setLoading(true);
  try {
    const userId = localStorage.getItem("userId");

    if (discordChannels.length > 0) {
      await updateDiscordChannels(userId, discordChannels);
      message.success("Updated Discord channels");
    } else {
      await updateDiscordChannels(userId, []);
    }

    if (telegramChannels.length > 0) {
      await updateTelegramChannels(userId, telegramChannels);
      message.success("Updated Telegram channels");
    } else {
      await updateTelegramChannels(userId, []);
    }

    if (isOnboarding) {
      const response = await completeOnboarding(userId);
      if (response.message === "Onboarding completed successfully") {
        message.success("Onboarding completed successfully!");
      }
    }

    if (onSuccessCallback) {
      onSuccessCallback();
    }

  } catch (error) {
    console.error("Error in channel operations:", error);
    message.error(error.message || "Failed to complete operation");
  } finally {
    setLoading(false);
  }
};

// Edit an existing channel (Discord or Telegram)
export const editChannel = async (channelId, channelData) => {
  try {
    const user_id = localStorage.getItem("userId");
    const response = await axios.put(`${API_BASE_URL}/user/channels/${channelId}`, {
      user_id,
      ...channelData
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update channel");
  }
};

export const updateSocialUsernames = async (userId, { discordUsername, telegramUsername }) => {
  try {
    const response = await axios.patch(`${BACKEND_URL}/user/update-social-usernames`, {
      userId,
      discordUsername,
      telegramUsername
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update social usernames");
  }
};